import type {Pointer} from '@wix/document-services-types'
import {type CreateExtArgs, pointerUtils} from '@wix/document-manager-core'
import type {ComponentsMetadataAPI} from '../../../componentsMetadata/componentsMetadata'
import type {DataModelExtensionAPI} from '../../../dataModel/dataModel'
import {VIEW_MODES, DATA_TYPES, DOM_ID_PREFIX} from '../../../../constants/constants'
import {stripHashIfExists} from '../../../../utils/refArrayUtils'
import {getComponentType} from '../../../../utils/dalUtils'

const {getInnerPointer} = pointerUtils

function splitMobileComponentPropsIfNeeded(createExtArgs: CreateExtArgs, componentPointer: Pointer): void {
    const {extensionAPI, dal, pointers} = createExtArgs
    const {componentsMetadata} = extensionAPI as ComponentsMetadataAPI
    const {dataModel} = extensionAPI as DataModelExtensionAPI
    const {components: fullComponents} = pointers.full

    if (componentPointer.type === VIEW_MODES.DESKTOP) {
        return
    }

    if (componentsMetadata.isMobileComponentPropertiesSplit(componentPointer)) {
        return
    }

    const equivalentCompInDesktopPointer = pointers.structure.getDesktopPointer(componentPointer)
    const clonedDesktopPropsItem = dataModel.components.getItem(equivalentCompInDesktopPointer, DATA_TYPES.prop)
    const desktopProps = dal.get(getInnerPointer(equivalentCompInDesktopPointer, 'propertyQuery'))
    const desktopPropsItemId = desktopProps && stripHashIfExists(desktopProps)
    const mobilePropsItemId = DOM_ID_PREFIX.MOBILE + desktopPropsItemId
    const mobileCompPointer = pointers.structure.getMobilePointer(componentPointer)
    const pageId =
        pointers.structure.getPageOfComponent(mobileCompPointer)?.id ||
        fullComponents.getPageOfComponent(mobileCompPointer)?.id

    if (!pageId) {
        return
    }

    dataModel.addItem(clonedDesktopPropsItem, DATA_TYPES.prop, pageId, mobilePropsItemId)
    dal.set(getInnerPointer(mobileCompPointer, 'propertyQuery'), mobilePropsItemId)
}

function updatePropertiesItem(createExtArgs: CreateExtArgs, componentPointer: Pointer, propertiesItem: any): void {
    const {dal, extensionAPI, eventEmitter, EVENTS} = createExtArgs
    const {dataModel} = extensionAPI as DataModelExtensionAPI
    const componentType = getComponentType(dal, componentPointer)

    eventEmitter.emit(EVENTS.COMPONENTS.PROPERTIES_UPDATE_BEFORE, componentPointer, componentType, propertiesItem)
    dataModel.components.addItem(componentPointer, DATA_TYPES.prop, propertiesItem)
    eventEmitter.emit(EVENTS.COMPONENTS.PROPERTIES_UPDATE_AFTER, componentPointer, componentType, propertiesItem)
}

export function handleColumnDeletion(
    createExtArgs: CreateExtArgs,
    deletedCompPointer: Pointer,
    deletingParent: boolean
): void {
    if (deletingParent) {
        return
    }

    const {pointers} = createExtArgs
    const {components: fullComponents} = pointers.full

    const columnsContainerPtr =
        pointers.structure.getParent(deletedCompPointer) || fullComponents.getParent(deletedCompPointer)
    const columnPointers =
        pointers.structure.getChildren(columnsContainerPtr!) || fullComponents.getChildren(columnsContainerPtr!)
    const numberOfColumns = columnPointers.length

    if (numberOfColumns === 2) {
        const noMargin = {
            rowMargin: 0,
            columnsMargin: 0,
            siteMargin: 0,
            frameMargin: 0
        }

        splitMobileComponentPropsIfNeeded(createExtArgs, columnsContainerPtr!)
        updatePropertiesItem(createExtArgs, columnsContainerPtr!, noMargin)
    }
}
